module.exports = __webpack_public_path__ + "static/media/opa_thumb.9c90054e.jpg";